import {Form} from "../../../helpers/forms/Form";

// noinspection JSUnusedGlobalSymbols -- Imported via d.ts
class ProductionRoleForm extends Form {

	constructor(config) {
		super({
			fields: [
				'role',
				'role_gender',
				'production_id',
				'id',
			],
			...config,
		});
	}
}

export {ProductionRoleForm}
